// T-053: the antiforgery token for every state-changing request (jQuery AJAX, fetch, forms without the tag helper and
// links marked data-method="post"). Same behaviour as the old inline _AntiforgeryScript, but external (CSP) and
// reading the token from <meta name="ds-csrf">. Load after jQuery (when present) and before page scripts.
// `var`, plain functions and the old-browser checks are kept on purpose: it runs on every page, first.
/* eslint-disable no-var, @typescript-eslint/no-unnecessary-condition */
(function () {
  var meta = document.querySelector<HTMLMetaElement>('meta[name="ds-csrf"]');
  var token = meta ? meta.content : '';
  var safeMethod = /^(GET|HEAD|OPTIONS|TRACE)$/i;
  function isSameOrigin(url: string): boolean {
    try {
      return new URL(url, window.location.href).origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  if (window.jQuery) {
    (jQuery.ajaxSetup as (o: object) => void)({
      beforeSend: function (this: { crossDomain?: boolean }, xhr: XMLHttpRequest, settings: { type?: string }) {
        if (!safeMethod.test(settings.type || 'GET') && !this.crossDomain)
          xhr.setRequestHeader('RequestVerificationToken', token);
      },
    });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target as HTMLFormElement | null;
      if (!form || !form.getAttribute) return;
      // attributes, not form.method/form.action: an input named "action" or "method" would shadow those properties
      if ((form.getAttribute('method') || '').toUpperCase() !== 'POST') return;
      if (!isSameOrigin(form.getAttribute('action') || window.location.href)) return;
      if (form.querySelector('input[name="__RequestVerificationToken"]')) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = '__RequestVerificationToken';
      input.value = token;
      form.appendChild(input);
    },
    true,
  );

  // actions that change data accept only POST (T-012): a link with data-method="post" becomes a POST form
  window.ojePost = function (url, target) {
    if (!isSameOrigin(url)) return; // the token never leaves this site
    var form = document.createElement('form');
    form.method = 'post';
    form.action = url;
    if (target) form.target = target;
    form.style.display = 'none';
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = '__RequestVerificationToken';
    input.value = token;
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  };
  document.addEventListener('click', function (e) {
    var link =
      e.target && (e.target as Element).closest
        ? (e.target as Element).closest<HTMLAnchorElement>('a[data-method="post"]')
        : null;
    if (!link || e.defaultPrevented) return;
    e.preventDefault();
    // ds.js asks first (capture phase); if it has not loaded yet, a confirm-marked action still asks before posting
    if (
      link.hasAttribute('data-ds-confirm') &&
      !link.getAttribute('data-ds-confirmed') &&
      !window.confirm(link.getAttribute('data-ds-confirm')!)
    )
      return;
    window.ojePost(link.href, link.getAttribute('target'));
  });

  // the token goes only to same-origin requests, never to other services
  // eslint-disable-next-line @typescript-eslint/unbound-method -- called with its owner (fetch on window, a rule of makeRules that does not use this)
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
      var isRequest = typeof Request !== 'undefined' && input instanceof Request;
      var url = isRequest ? (input as Request).url : String(input);
      var method = ((init && init.method) || (isRequest ? (input as Request).method : 'GET')).toUpperCase();
      if (!safeMethod.test(method) && isSameOrigin(url)) {
        init = init || {};
        init.headers = new Headers(init.headers || (isRequest ? (input as Request).headers : {}));
        init.headers.set('RequestVerificationToken', token);
      }
      return nativeFetch(input, init);
    };
  }
})();
